export const toCurrency = priceAsNumber => {
  // check if priceAsNumber has a value and is a number type
  if (typeof priceAsNumber === 'number') {
    // if the number has decimals, change it to always have 2 decimals
    const priceAsNumberWithCorrectDecimals = priceAsNumber % 1 === 0 ? priceAsNumber : priceAsNumber.toFixed(2);

    const priceString = priceAsNumberWithCorrectDecimals
      .toString() // stringify our price number
      .replace(/\B(?=(\d{3})+(?!\d))/g, ' ') // add space as thousand separator
      .replace(/\.([0-9]{2})$/g, ',$1'); // replace decimal divider "." with a ","

    return `${priceString} kr`;
  }

  return false;
};



// WEBPACK FOOTER //
// ./src/util/toCurrency.js